import request from "./request";

const AuditLogService = {
    GetAuditLogs: async (tableName, skip, take, context, signal) => {
        return await request.sendRequest(
            `/audit/${tableName}/${skip}/${take}`,
            context.token, signal
        );
    },
  GetAuditLogsByStatus: async (tableName, status, skip, take, context, signal) => {
  // URL: /audit/vmlist/I/0/20
  return await request.sendRequest(
    `/audit/${tableName}/${status}/${skip}/${take}`,
    context.token, signal
  );
},
};

export default AuditLogService;